import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Template } from './ImportParticipantModal.styles';
import Modal from '../../HOC/Modal/Modal';
import Dropzone from '../Dropzone/Dropzone';

interface IImportParticipantModal {
  active: boolean;
  onClose: () => void;
  onConfirm?: () => Promise<void>;
}

const ImportParticipantModal: FC<IImportParticipantModal> = ({ active, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      active={active}
      callToAction={() => null}
      closeModal={onClose}
      buttonNames={{
        cancel: t('viewSurvey.participants.modals.import.close'),
        action: '',
      }}
      width="500px"
      top={'25vh'}
      title={t('viewSurvey.participants.listHead.importParticipants')}
      noC2AButton
    >
      <div>
        <Dropzone />
        <Template>
          <b>{t('viewSurvey.participants.modals.import.question')}</b>{' '}
          {t('viewSurvey.participants.modals.import.getTemplate')}
          <span>{t('viewSurvey.participants.modals.import.here')}</span>.
        </Template>
      </div>
    </Modal>
  );
};

export default ImportParticipantModal;
